(function () {
  if (window.__cnRestockInit) return;
  window.__cnRestockInit = true;

  var API = 'https://cornier-os.vercel.app/api/restock/subscribe';
  var data = null;
  function config() {
    if (data) return data;
    var el = document.querySelector('script[type="application/json"][data-cn-restock]');
    if (!el) return null;
    try { data = JSON.parse(el.textContent); } catch (e) { data = null; }
    return data;
  }

  function currentId() {
    var i = document.querySelector('product-form form input[name="id"]');
    return i ? i.value : null;
  }

  function formatMoneyJPY(cents) {
    return '¥' + Math.round(cents / 100).toLocaleString('ja-JP');
  }

  function formatMoneyLocalized(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'JPY';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return currency + ' ' + Math.round(cents / 100).toLocaleString();
    }
  }

  function formatPrice(cents) {
    cents = Number(cents);
    if (!isFinite(cents)) return '';
    if (document.body.getAttribute('data-locale-jp') === 'true') {
      return formatMoneyJPY(Math.round((cents * 10) / 11)) + ' (' + formatMoneyJPY(cents) + ' tax in)';
    }
    return formatMoneyLocalized(cents);
  }

  var TEXT = {
    ja: {
      button: '再入荷時に通知', title: '再入荷通知', lead: '', label: 'メールアドレス', placeholder: '登録するメールをご入力ください。',
      submit: '登録', other: '別のメールアドレスで登録する', noteTo: '商品が再入荷されましたら、次のメールにてお知らせいたします：', note: '商品が再入荷されましたら、上記のメールにてお知らせいたします。', close: '閉じる',
      ok: '再入荷通知が登録されました。', invalid: 'メールアドレスを正しく入力してください。',
      rate: '短時間に何度も送信されました。しばらくしてからもう一度お試しください。',
      fail: '登録できませんでした。時間をおいてもう一度お試しください。', net: '通信できませんでした。時間をおいてもう一度お試しください。'
    },
    en: {
      button: 'Email me when available', title: 'Email me when available', lead: 'Register your email address below to receive an email as soon as this becomes available again',
      label: 'Email', placeholder: 'Enter your email', submit: 'SUBSCRIBE', other: 'Use a different email address', noteTo: 'We will email you once the product becomes available: ', note: 'We will send you an email once the product becomes available', close: 'Close',
      ok: 'You are subscribed. We will email you when this is back in stock.', invalid: 'Please enter a valid email address.',
      rate: 'Too many attempts. Please try again in a few minutes.',
      fail: 'We could not register your email. Please try again later.', net: 'Connection failed. Please try again later.'
    }
  };
  function T() { return TEXT[document.body.getAttribute('data-locale-jp') === 'true' ? 'ja' : 'en']; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  function sync() {
    var cfg = config();
    var buttons = document.querySelector('product-form .product-form__buttons');
    if (!cfg || !buttons) return;
    var id = currentId();
    var v = id && cfg.variants[id];
    var existing = buttons.querySelector('.cn-restock-btn');
    if (!v || v.available) {
      if (existing) existing.remove();
      return;
    }
    if (existing) { existing.setAttribute('data-variant', id); return; }
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'cn-restock-btn button button--full-width button--primary';
    b.setAttribute('data-variant', id);
    b.textContent = T().button;
    b.addEventListener('click', function () { openModal(b.getAttribute('data-variant')); });
    buttons.appendChild(b);
  }

  var modal = null;
  function closeModal() {
    if (modal) { modal.remove(); modal = null; }
    document.removeEventListener('keydown', onKey);
    document.body.classList.remove('cn-restock-lock');
  }
  function onKey(e) { if (e.key === 'Escape') closeModal(); }

  function openModal(id) {
    var cfg = config();
    var v = cfg && cfg.variants[id];
    if (!v) return;
    closeModal();
    var t = T();
    // ログイン中のお客様はアカウントのメールで登録（別のメールも選べる）
    var acct = typeof cfg.email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(cfg.email) ? cfg.email : '';
    var name = cfg.title + (cfg.single || !v.option ? '' : ' ( ' + v.option + ' )');
    modal = document.createElement('div');
    modal.className = 'cn-restock-overlay';
    modal.innerHTML =
      '<div class="cn-restock-modal" role="dialog" aria-modal="true" aria-labelledby="cn-restock-title">' +
      '<button type="button" class="cn-restock-close" aria-label="' + esc(t.close) + '">&times;</button>' +
      '<h2 id="cn-restock-title" class="cn-restock-title">' + esc(t.title) + '</h2>' +
      (t.lead ? '<p class="cn-restock-lead">' + esc(t.lead) + '</p>' : '') +
      '<div class="cn-restock-item">' + (v.image ? '<img src="' + esc(v.image) + '" alt="" width="64">' : '') +
      '<div><div class="cn-restock-name">' + esc(name) + '</div><div class="cn-restock-price">' + esc(formatPrice(v.price)) + '</div></div></div>' +
      '<form class="cn-restock-form" novalidate>' +
      '<div class="cn-restock-fields"' + (acct ? ' hidden' : '') + '>' +
      '<label class="cn-restock-label" for="cn-restock-email">' + esc(t.label) + '</label>' +
      '<input id="cn-restock-email" class="cn-restock-input" type="email" inputmode="email" autocomplete="email" placeholder="' + esc(t.placeholder) + '" required>' +
      '</div>' +
      '<input class="cn-restock-hp" type="text" name="website" tabindex="-1" autocomplete="off" aria-hidden="true">' +
      '<button type="submit" class="cn-restock-submit">' + esc(t.submit) + '</button>' +
      (acct ? '<button type="button" class="cn-restock-other">' + esc(t.other) + '</button>' : '') +
      '<p class="cn-restock-note">' + esc(acct ? t.noteTo + acct : t.note) + '</p>' +
      '<p class="cn-restock-msg" role="status" hidden></p>' +
      '</form></div>';
    document.body.appendChild(modal);
    document.body.classList.add('cn-restock-lock');
    document.addEventListener('keydown', onKey);
    modal.querySelector('.cn-restock-close').addEventListener('click', closeModal);
    modal.addEventListener('mousedown', function (e) { if (e.target === modal) closeModal(); });
    var form = modal.querySelector('form');
    var msg = modal.querySelector('.cn-restock-msg');
    var input = modal.querySelector('.cn-restock-input');
    var submit = modal.querySelector('.cn-restock-submit');
    var fields = modal.querySelector('.cn-restock-fields');
    var other = modal.querySelector('.cn-restock-other');
    var note = modal.querySelector('.cn-restock-note');
    var useAcct = !!acct;
    if (other) other.addEventListener('click', function () {
      useAcct = false;
      fields.hidden = false;
      other.hidden = true;
      note.textContent = t.note;
      input.focus();
    });
    if (!acct) setTimeout(function () { input.focus(); }, 50);

    function show(text, ok) {
      msg.hidden = false;
      msg.textContent = text;
      msg.className = 'cn-restock-msg ' + (ok ? 'is-ok' : 'is-err');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = useAcct ? acct : input.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { show(t.invalid, false); return; }
      submit.disabled = true;
      submit.classList.add('is-loading');
      fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, variant_id: Number(id), lang: document.body.getAttribute('data-locale-jp') === 'true' ? 'ja' : 'en', website: form.elements.website.value })
      }).then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          submit.classList.remove('is-loading');
          if (res.ok && res.j.ok) { show(t.ok, true); input.value = ''; submit.disabled = true; return; }
          submit.disabled = false;
          if (res.j && res.j.error === 'email') show(t.invalid, false);
          else if (res.j && res.j.error === 'rate') show(t.rate, false);
          else show(t.fail, false);
        })
        .catch(function () {
          submit.classList.remove('is-loading');
          submit.disabled = false;
          show(t.net, false);
        });
    });
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; sync(); }, 30);
  }
  document.addEventListener('change', function () { setTimeout(schedule, 60); setTimeout(schedule, 500); }, true);
  var tries = 0;
  (function hook() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      try { subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(schedule, 0); }); } catch (e) { }
      return;
    }
    if (++tries < 50) setTimeout(hook, 100);
  })();
  var lastKey = '';
  setInterval(function () {
    var btn = document.querySelector('product-form .product-form__submit');
    var key = currentId() + '|' + (btn ? btn.disabled : '') + '|' + (document.querySelector('.cn-restock-btn') ? 1 : 0);
    if (key !== lastKey) { lastKey = key; schedule(); }
  }, 600);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
